import UberServ from '@api/Uber/UberServ';
import { Order } from '@api/Orders/Order';
import { BranchOffice } from '@api/BranchOffices/BranchOffice';

class UberCtrl {
    createQuote = async (order: Order, branchOffice: BranchOffice): Promise<any> => {
        return await UberServ.createQuote(order, branchOffice);
    };
    createDelivery = async (order: Order, branchOffice: BranchOffice, quoteId: string): Promise<void> => {
        return await UberServ.createDelivery(order, branchOffice, quoteId);
    };
    getDelivery = async (deliveryId: string): Promise<any> => {
        return await UberServ.getDelivery(deliveryId);
    };
    cancelDelivery = async (deliveryId: string): Promise<void> => {
        return await UberServ.cancelDelivery(deliveryId);
    };
}
export default UberCtrl;
